import { useEffect } from 'react';
import { useIsFocusedTab, useLogAnalyticsEvent } from 'shared/src/hooks';

export const useLogViewLikedGoods = (isActive: boolean) => {
  const logAnalyticsEvent = useLogAnalyticsEvent();
  const isFocusedTab = useIsFocusedTab();

  useEffect(() => {
    if (!isFocusedTab || !isActive) return;
    logAnalyticsEvent({
      name: 'VIEW_LIKED_GOODS',
      channel: ['firebase', 'facebook', 'amplitude', 'braze', 'ablylog'],
    });
  }, [isFocusedTab, isActive, logAnalyticsEvent]);
};
